<template>
    <v-dialog
        v-model="dialog"
        :max-width="size.width"
        :max-height="size.height"
    >
    <template v-slot:activator="{ attrs }">
        <!-- Ejemplo de uso para scoped slot de boton en el componente padre  -->
        <!-- Enviar props o metodos con scope (del componente hijo) como en el caso de open  -->
        <!-- <template slot-scope="{ open }" slot="activate">
            <v-btn @click="open">HOLA</v-btn>
        </template> -->
        <slot name="activate" :open="open">
            <v-btn
                dark
                color="primary"
                class="my-auto"
                v-bind="attrs"
                @click="open"
            >
                Exportar a excel
            </v-btn>
        </slot>
    </template>
    <v-card class="pa-5">
        <v-card-title class="headline">
            Exportar datos
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col>
                    <h4>Filtrar<span v-if="filterName"> por: <strong>{{ filterName }}</strong></span></h4>
                </v-col>
            </v-row>
            <v-menu
                v-if="dateFilter"
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
                <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="date1"
                    label="Desde"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
                </template>
                <v-date-picker
                v-model="date1"
                @input="menu1 = false"
                ></v-date-picker>
            </v-menu>
            <v-menu
                v-if="dateFilter"
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
                <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="date2"
                    label="Hasta"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
                </template>
                <v-date-picker
                v-model="date2"
                @input="menu2 = false"
                ></v-date-picker>
            </v-menu>
        </v-card-text>
        <v-card-actions>
        <v-spacer></v-spacer>
        <slot name="exportBtn" :exportData="exportData">
            <v-btn
                dark
                rounded
                large
                color="primary"
                class="my-auto font-weight-black px-5"
                @click="exportData"
            >
                <v-icon>mdi-file-excel</v-icon>
                Exportar
            </v-btn>
        </slot>
        </v-card-actions>
    </v-card>
    </v-dialog>
</template>

<script>
import moment from 'moment'
import { json2excel } from 'js2excel'

export default {
  name: 'ExportTable',
  data () {
    return {
      dialog: false,
      menu1: false,
      menu2: false,
      date1: null,
      date2: null
    }
  },

  props: {
    mapFunction: {
      type: Function,
      default: item => item
    },
    reloadData: {
      type: Function,
      required: false
    },
    dataToExport: {
      type: Array,
      default: () => []
    },
    dateFilter: {
      type: String,
      default: null
    },
    filterName: {
      type: String,
      default: null
    },
    filterFormat: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    filterValue: {
      type: Object,
      required: false
    },
    size: {
      type: Object,
      default: () => Object.assign({ width: '400', height: 'auto' })
    },
    fileName: {
      type: String
    },
    headers: {
      type: Object
    }
  },

  methods: {
    async exportData () {
      if (this.reloadData && this.date1 && this.date2) {
        const reload = await this.reload()
        if (!reload) {
          return
        }
      }
      if (this.dataToExport.length < 1) {
        this.noData()
        return
      }
      try {
        let data = this.dataToExport.map(item => item)
        if (this.dateFilter && this.date1 && this.date2) {
          data = data.filter(item => moment(item[this.dateFilter], this.filterFormat).diff(moment(this.date1), 'days') >= 0 && moment(item[this.dateFilter], this.filterFormat).diff(moment(this.date2), 'days') <= 0)
        }
        const mappedData = data.map(this.mapFunction)

        const exportData = mappedData.map(row =>
          Object.fromEntries(
            Object.entries(row).map(([key, value]) => [
              this.headers[key] || key,
              value
            ])
          )
        )

        json2excel({
          data: exportData,
          name: this.fileName
        })
      } catch (error) {
        console.error('export error', error)
        this.error('Ocurrió un error al exportar los datos')
      }
      this.dialog = false
    },

    setDefaultDateFilters () {
      this.date1 = moment(this.filterValue.init, this.filterValue.format).format('YYYY-MM-DD')
      this.date2 = moment(this.filterValue.fin, this.filterValue.format).format('YYYY-MM-DD')
    },

    async reload () {
      try {
        await this.reloadData(this.date1, this.date2, 'YYYY-MM-DD')
        return true
      } catch (error) {
        this.error('Ocurrió un error al recargar los datos')
        return false
      }
    },

    noData () {
      this.$swal({
        title: 'Sin datos',
        html: '<p>No hay datos para exportar</p>',
        icon: 'warning',
        showCancelButton: false,
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#5c9df2',
        cancelButtonColor: '#d33',
        cancelButtonText: 'No',
        showCloseButton: true,
        allowOutsideClick: true
      })
    },

    error (error) {
      this.$swal({
        title: 'Error',
        html: `<p>${error}</p>`,
        icon: 'error',
        showCancelButton: false,
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#5c9df2',
        cancelButtonColor: '#d33',
        cancelButtonText: 'No',
        showCloseButton: true,
        allowOutsideClick: true
      })
    },

    open () {
      if (this.dateFilter) {
        if (this.filterValue) {
          this.setDefaultDateFilters()
        }
        this.dialog = true
      } else {
        this.exportData()
        this.dialog = false
      }
    }
  }
}
</script>

<style>

</style>
